import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAttributes } from 'src/app/models/IAttributes';
import { ToastrService } from 'ngx-toastr';
import { AssessmentClinicService } from 'src/app/Services/NewORNote/assessment.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ASCMaster } from '../ascmaster';
import { Defaults } from 'src/app/Utilities/defaults';


@Component({
  selector: 'app-ivsite',
  templateUrl: './ivsite.component.html',
  styleUrls: ['./ivsite.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class IVsiteComponent implements OnInit {

  columnsToDisplay = ['attributeName', 'attributeDesc', 'isActive'];
  headercolumnsToDisplay = ['IV Site', 'Description', 'Is Active',];
  expandedElement: IAttributes | null;
  public ASCTypeObj: IAttributes;
  public show: boolean = false;
  result: any;
  IVSites: IAttributes[] = [];
  public IVSiteDataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  showInfo() {
    this.ivsiteform.reset();
    this.show = !this.show;
    this.expandedElement = null;
  }

  ivsiteform: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private assessmentClinicService: AssessmentClinicService,
    private sharedService: SharedService,
    private ascMaster: ASCMaster) { }

  ngOnInit() {
    this.ivsiteform = this.formBuilder.group({
      ascTypeId: [''],
      name: ['',Validators.required],
      isActive: [''],
      description: [''],
    });
    this.getIVSiteData();
  }

  get f() { return this.ivsiteform.controls; }

  SaveIVSite() {
    if (this.ivsiteform.invalid) {
      return;
    }
    this.ASCTypeObj = new IAttributes();
    this.ASCTypeObj = this.ascMaster.createInstance(Defaults.ivSitesAttributeType, this.ivsiteform.value.name, this.ivsiteform.value.description);
    this.sharedService.saveAssessmentName(this.ASCTypeObj).subscribe(
      results => {
        this.result = results;
        this.getIVSiteData();
        this.ivsiteform.reset();
        this.toastr.success("Assessment Name Saved Successfully");
      }, (err: any) => console.log(err));
  }

  getIVSiteData() {
    this.assessmentClinicService.getMasterData().subscribe((data: IAttributes[]) => {
      this.IVSites = data.filter((attr: IAttributes) => attr.attributeType == Defaults.ivSitesAttributeType);
      this.IVSiteDataSource.data = this.IVSites;
      this.IVSiteDataSource.paginator = this.paginator;
    },
      (err: any) => console.log(err))
  }

  onCellClick(element: IAttributes) {
    this.show = false;
    this.ivsiteform.patchValue({
      name: element.attributeName,
      isActive: element.isActive,
      description: element.attributeDesc,
    });
  }

  upDateIVSite(element: IAttributes) {
    if (this.ivsiteform.invalid) {
      return;
    }
    this.ASCTypeObj = new IAttributes();
    this.ASCTypeObj = this.ascMaster.updateInstance(element.attributeId, Defaults.ivSitesAttributeType, this.ivsiteform.value.name, this.ivsiteform.value.description, this.ivsiteform.value.isActive);
    this.sharedService.saveAssessmentName(this.ASCTypeObj).subscribe(
      results => {
        this.result = results;
        this.getIVSiteData();
        this.toastr.success("Assessment Name Updated Successfully");
      }, (err: any) => console.log(err));
  }

  clearSaveASC(){
    this.ivsiteform.reset();
  }

  clearUpdatedASC(){
    this.ivsiteform.reset();
  }

}



